<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-search"
        :label="searchLabel"
        single-line
        hide-details
        class="d-none d-sm-block"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn class="ma-2" tile outlined color="primaryLigth" v-if="createEnable" @click="addNewStudy">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('add study') }}
      </v-btn>
      <v-btn class="ma-2" tile outlined color="primaryLigth" @click="updateTable">
        <v-icon left>mdi-refresh</v-icon>
        {{ $t('Refresh') }} ({{ timerCounter }})
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="studies"
      :search="search"
      :loading="loading"
      :items-per-page="itemsPerPage"
      :footer-props="footerProps"
      class="elevation-1"
      @click:row="handleUserTableClick"
    >
    </v-data-table>

    <NewStudyModal ref="newStudyModal"></NewStudyModal>
    <UpdateStudyModal ref="updateStudyModal"></UpdateStudyModal>
  </v-card>
</template>

<script>
import axios from "axios";
import i18n from "../../i18n";
import EventBus from "../../event-bus";

import NewStudyModal from "./NewStudyModal";
import UpdateStudyModal from "./UpdateStudyModal";

export default {
  name: "WorklistTable",
  components: {
    NewStudyModal,
    UpdateStudyModal,
  },
  data: () => ({
    loading: true,
    flushLoading: false,
    search: "",
    searchLabel: i18n.t("search"),
    itemsPerPage: 50,
    headers: [
      {
        text: i18n.t("Accession Number"),
        align: "start",
        filterable: true,
        value: "dicom.accessionNumber",
      },
      { text: i18n.t("Patient Name"), value: "dicom.patientName" },
      { text: i18n.t("Patient Id"), value: "dicom.patientId" },
      { text: i18n.t("Patient Sex"), value: "dicom.patientSex" },
      {
        text: i18n.t("Modality"),
        value: "dicom.scheduledProcedureStepSequence.modality",
      },
      {
        text: i18n.t("Study Start Date"),
        value:
          "dicom.scheduledProcedureStepSequence.scheduledProcedureStepStartDate",
      },
      {
        text: i18n.t("AE Title"),
        value: "dicom.scheduledProcedureStepSequence.scheduledStationAeTitle",
      },
      {
        text: i18n.t("Expiration"),
        value: "expireAt",
      },
    ],
    timerCounter: 0,
    timerSeconds: 1,
    timerHandle: null,
    studies: [],
    createEnable: false,
    updateEnable: false,
    deleteEnable: false,
    footerProps: {
      "items-per-page-options": [25, 50, 100, -1],
      "items-per-page-text": i18n.t("Rows per page"),
    },
  }),
  mounted() {
    // Permissions
    if (this.$store.getters.resources.worklist.create) {
      this.createEnable = true;
    }

    if (this.$store.getters.resources.worklist.update) {
      this.updateEnable = true;
    }

    if (this.$store.getters.resources.worklist.delete) {
      this.deleteEnable = true;
    }

    this.init();
  },
  destroyed() {
    clearInterval(this.timerHandle);
  },
  methods: {
    init() {
      this.updateTable();
      this.countDown();
    },
    countDown() {
      this.timerHandle = setInterval(() => {
        if (this.timerCounter != 0) {
          this.timerCounter = this.timerCounter - 1;
        } else {
          this.updateTable();
        }
      }, this.timerSeconds * 1000);
    },
    sendError(error) {
      this.loading = false;

      if (error.response) {
        if (
          error.response.status == 500 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }
    },
    updateTable() {
      this.timerCounter = 5;

      axios({
        url: "/api/v1/worklist/studies",
        method: "GET",
      })
        .then((response) => {
          this.loading = false;
          this.studies = [];

          if (response.data.status && response.data.status == "done") {
            // List
            this.studies = response.data.studies;

            for (let i = 0; i < this.studies.length; i++) {
              // Expire At
              if ("expireAt" in this.studies[i]) {
                // Change expiration date to text.
                let message = this.$moment(this.studies[i].expireAt)
                  .locale(this.$store.getters.locale)
                  .tz(this.$store.getters.timezone)
                  .fromNow();
                this.studies[i].expireAt =
                  message.charAt(0).toUpperCase() + message.slice(1);
              } else {
                this.studies[i].expireAt = i18n.t("No expiration");
              }

              // Patient Name
              if (!("patientName" in this.studies[i].dicom)) {
                this.studies[i].dicom.patientName = "";
              } else {
                this.studies[i].dicom.patientName = this.studies[
                  i
                ].dicom.patientName.replace("^", " ");
              }

              // Patient Id
              if (!("patientId" in this.studies[i].dicom)) {
                this.studies[i].dicom.patientId = "";
              }

              // Patient Sex
              if (!("patientSex" in this.studies[i].dicom)) {
                this.studies[i].dicom.patientSex = "";
              }

              if ("scheduledProcedureStepSequence" in this.studies[i].dicom) {
                // Modality
                if (
                  !(
                    "modality" in
                    this.studies[i].dicom.scheduledProcedureStepSequence
                  )
                ) {
                  this.studies[
                    i
                  ].dicom.scheduledProcedureStepSequence.modality = "";
                }

                // Study Start Date
                if (
                  !(
                    "scheduledProcedureStepStartDate" in
                    this.studies[i].dicom.scheduledProcedureStepSequence
                  )
                ) {
                  this.studies[
                    i
                  ].dicom.scheduledProcedureStepSequence.scheduledProcedureStepStartDate =
                    "";
                }

                // AE Title
                if (
                  !(
                    "scheduledStationAeTitle" in
                    this.studies[i].dicom.scheduledProcedureStepSequence
                  )
                ) {
                  this.studies[
                    i
                  ].dicom.scheduledProcedureStepSequence.scheduledStationAeTitle =
                    "";
                }
              } else {
                this.studies[i].dicom.scheduledProcedureStepSequence = {
                  modality: "",
                  scheduledProcedureStepStartDate: "",
                  scheduledStationAeTitle: "",
                };
              }
            }
          } else {
            EventBus.$emit("SHOW_ERROR", response.data.error);
          }
        })
        .catch((error) => {
          this.sendError(error);
        });
    },
    addNewStudy() {
      this.$refs.newStudyModal.show();
    },
    handleUserTableClick(entry) {
      this.$refs.updateStudyModal.show(entry.id);
    },
  },
};
</script>

<style scoped>
.v-input {
  text-transform: capitalize;
}
</style>